import typeUtils from '../../helpers/utils/typeUtils.js.es6';

const Sort = ({
    onClick,
    active,
    dir,
    disabled,
    label,
    title = ''
}) => {
    const isDisabled = !typeUtils.isBoolean(disabled) ? false : disabled;
    const tooltip = title || label

    return isDisabled === true ? (
        <div className="bl-grid__col-header__sort-container">
            <span
                title={tooltip}
                className="bl-grid__col-header__sort">
                { (label || '') }
            </span>
        </div>
    ) : (
        <div className="bl-grid__col-header__sort-container">
            <a
                className={ 'bl-grid__col-header__sort' + (active ? ' bl-grid__sort--active' : '')}
                href="#sort"
                onClick={ onClick }
                title={tooltip}>
                <span className="pull-right bl-grid__sort--arrows">
                    <i className={'fa fa-caret-up' + (dir === 'asc' ? ' active' : '')} />
                    <i className={'fa fa-caret-down' + (dir === 'desc' ? ' active' : '')} />
                </span>
                { (label || '') }
            </a>
        </div>
    );
};

export default Sort;
